export enum FormContainerModifier {
  MARGIN_LEFT = 'form__container--margin-left',
  NO_PADDING_VERTICAL = 'form__container--no-padding-vertical',
  NO_PADDING_HORIZONTAL = 'form__container--no-padding-horizontal',
  ALIGN_RIGHT = 'form__container--align-right',
  NO_PADDING = 'form__container--no-padding',
  PADDING_BOTTOM = 'form__container--padding-bottom',
  NO_PADDING_TOP = 'form__container--no-padding-top',
  NO_PADDING_BOTTOM = 'form__container--no-padding-bottom',
  WIDTH_100 = 'form__container--width-100',
  WIDTH_70_CHARS = 'form__container--width-70-chars',
}
